import { render, staticRenderFns } from "./NewExtraField.vue?vue&type=template&id=2ddf76f6&"
import script from "./NewExtraField.vue?vue&type=script&lang=js&"
export * from "./NewExtraField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports